import React from 'react';
import { Box } from 'vindi-ds-components';

import Card from '@components/card';
import tokens from 'vindi-ds-tokens';

const CardsChargesPending = ({ data }) => {
  const lisCards = [
    {
      title: 'Total cobrado',
      description: data.charged.total,
      subDescription: `${data.charged.send} cobranças emitidas`,
      color: tokens.color.prsm.neutral[800].value,
    },
    {
      title: 'Pago',
      description: data.paid_out.total,
      subDescription: `${data.paid_out.send} cobranças pagas`,
      color: tokens.color.prsm.feedback.success[600].value,
    },
    {
      title: 'A vencer',
      description: data.to_overdue.total,
      subDescription: `${data.to_overdue.send} cobranças a vencer`,
      colorPin: tokens.color.prsm.feedback.warning[600].value,
      color: tokens.color.prsm.feedback.warning[800].value,
    },
    {
      title: 'Vencido',
      description: data.overdue.total,
      subDescription: `${data.overdue.send} cobranças vencidas`,
      color: tokens.color.prsm.feedback.error[600].value,
    },
  ];

  return (

    <Box
      display='flex'
      flexDirection={{ xs: 'column', md: 'row' }}
      gap={2}
      mt={5}
    >
      {
        lisCards.map((card) => (
          <Card
            title={card.title}
            description={card.description}
            subDescription={card.subDescription}
            colorPin={card?.colorPin}
            color={card.color}
            currency
          />
        ))
      }
    </Box>
  );
};

export default CardsChargesPending;
